<div class="page"><a [routerLink]="page?.link">{{page?.name}}</a></div>
<div class="content">{{content}}</div>
